<template>
  <div
    class="w-full h-screen flex flex-col items-center justify-center text-center bg-blue-light"
  >
    <main class="max-w-lg mx-auto">
      <img
        src="https://res.cloudinary.com/iubh/image/upload/v1613137329/07%20-%20Pages/Unit%20Bilder/Duales%20Studium/Bewerberportal/iubh-duales-studium-error_kleylx.svg"
        alt="Error Image"
      />
      <div class="max-w-480">
        <head-line level="h1" bg="black" class="mt-4">Ooops...</head-line>
        <div class="mt-4">
          <div>
            Es ist ein Fehler aufgetreten.<br />Du hast nun folgende
            Möglichkeiten:
          </div>
          <div class="flex flex-col gap-2 items-start text-left mt-4">
            <div>
              <a href="/" class="underline"
                ><svg-icon name="refresh" class="mr-2" />Seite neu laden</a
              >
            </div>
            <div>
              <span
                @click="authStore.logoutUser"
                class="underline cursor-pointer"
                ><svg-icon name="logout" class="mr-2" />Ausloggen</span
              >
            </div>
            <div>
              <svg-icon name="envelope" class="mr-2" />Kontaktiere den Support
              unter:<br />
              <a
                href="mailto:bewerbungsportal-dualesstudium@iu.org"
                class="underline ml-6"
                >bewerbungsportal-dualesstudium@iu.org</a
              >
            </div>
          </div>
        </div>
        <div class="mt-8 text-red-dark bg-gray-lighter py-1 px-2">
          Fehler: ({{ appStore.state.apiError?.code }})
          <span v-if="$te(`error.backend.${appStore.state.apiError?.code}`)">{{
            $t(`error.backend.${appStore.state.apiError?.code}`)
          }}</span>
          <span v-else-if="appStore.state.apiError?.message">{{
            appStore.state.apiError?.message
          }}</span>
        </div>
        <div
          v-if="appStore.state.apiError?.code === 1001"
          class="text-black px-2 mt-2"
        >
          <svg-icon name="info-circle" class="mr-2" />Falls Du Deinen Account
          gerade erst erstellt hast, versuche es in wenigen Minuten noch einmal.
        </div>
        <div
          v-if="appStore.state.apiError?.code === 1006"
          class="text-black px-2 mt-2"
        >
          <svg-icon name="info-circle" class="mr-2" />Für Deinen Account wurde
          keine gültige Bewerbung gefunden. Bitte kontaktiere Deine
          Studienberatung für Unterstützung.
        </div>
        <div
          v-if="appStore.state.apiError?.code === 10002"
          class="text-black px-2 mt-2"
        >
          <svg-icon name="info-circle" class="mr-2" />Für Deinen Account wurde
          keine Bewerbung gefunden. Bitte probiere es später noch einmal.
        </div>
      </div>
    </main>
  </div>
</template>

<script setup lang="ts">
import appStore from '@/stores/app.store'
import HeadLine from '@/components/HeadLine.vue'
import SvgIcon from '@/components/SvgIcon.vue'
import authStore from '@/stores/auth.store'
</script>
